<template>
	<header class="nav-header-md"><!-- position: sticky; top: 0px; -->
		
		<div class="col-12 pr-0">
			<div>
				<div class="d-flex nav-md" style="justify-content: space-between;">
					
					<div class="my-auto pr-3 d-flex">
						<!--b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret right>
							<template v-slot:button-content>
								<b-button variant="primary" style="min-width: 8em;padding: 10px 14px 10px 10px;font-weight: 600;">
									<span><i class="fa fa-user-circle-o"></i> Clients</span> <i class="fa fa-angle-down" style="float: right; padding-top: 4px;"></i>
								</b-button>
							</template>
							<b-dropdown-item v-for="(item, id) in clients" v-bind:key="`cl-${id}`" @click="selectClient(item)" :active="item.selected">  disabled
								<div class="shortcut-menu-item-inner">
									{{ item.name }} {{ item.selected }}
								</div>
							</b-dropdown-item>
							<b-dropdown-divider></b-dropdown-divider>
							<b-dropdown-item :to="{path: '/settings/clients', params: {page: 'clients'}}">
								<div class="shortcut-menu-item-inner">
									<i class="fa fa-users"></i> Manage Clients
								</div>
							</b-dropdown-item>
						</b-dropdown-->
						<div class="my-auto pr-2 title-select">
							{{ $t('CurrentlyManaging') }}
							<i class="fa fa-spinner fa-spin" v-if="loadingAction"></i>
							<i class="fa fa-question-circle text-secondary" v-else id="popover-target-1"></i>
							<b-popover target="popover-target-1" triggers="hover" placement="top">
								<!--template v-slot:title>Popover Title</template-->
								{{ $t('PopoverChangeWorkSpace') }}
							</b-popover>
						</div>
						
						<div>
							<multi-select faIcon="fa-street-view" :options="$store.state.WorkSpaces" :selected="$store.state.SelectedClient" :label="$t('Workspaces')" placeholderType="title" @filterChange="selectClient" caret :titleOption="$t('Workspaces')" class="workspace-multiselect">
								<template v-if="!$store.state.WhiteLabel || $store.state.IsAdmin" v-slot:footer>
									<div class="option-drop">{{ $t('Options') }}</div>
									<span @click="ShowModalAdd">
										<i class="fa fa-plus"></i> {{ $t('NewWorkspace') }}
									</span>
									<!--span @click="$bvModal.show('modal-list-clients')">
										<i class="fa fa-align-justify"></i> Manage Workspaces
									</span-->
								</template>
							</multi-select>
						</div>
						
						<!--b-dropdown size="lg"  variant="link" toggle-class="text-decoration-none" no-caret class="add-actions-md" right>
							<template v-slot:button-content>
								<b-button variant="primary" style="width: 7em;padding: 10px 14px 10px 0px;font-weight: 600;"><span>Add</span> <i class="fa fa-angle-down" style="float: right; padding-top: 4px;"></i></b-button>
							</template>
							<b-dropdown-item href="#">
								<router-link :to="{name: 'newSource'}">
									<img src="https://old.ohmylead.com/assets/new/images/menu/leadsources-black.svg">
									<div class="shortcut-menu-item-inner">Lead Source<span>Add a new lead source</span></div>
								</router-link>
							</b-dropdown-item>
							<b-dropdown-item href="#">
								<router-link :to="{name: 'crms'}">
									<img src="https://old.ohmylead.com/assets/new/images/menu/integration-black.svg">
									<div class="shortcut-menu-item-inner">CRM<span>Send leads to your CRM</span></div>
								</router-link>
							</b-dropdown-item>
							<b-dropdown-item href="#">
								<router-link :to="{name: 'emailMarketing'}">
									<img src="https://old.ohmylead.com/assets/new/images/menu/automation-black.svg">
									<div class="shortcut-menu-item-inner">Email Service<span>Send leads to your ESP</span></div>
								</router-link>
							</b-dropdown-item>
							<b-dropdown-item href="#">
								<router-link :to="{path: '/settings/team', params: {page: 'team'}}">
									<img src="https://old.ohmylead.com/assets/new/images/menu/team-black.svg">
									<div class="shortcut-menu-item-inner">
										Team Member
										<span>Invite a new team member</span>
									</div>
								</router-link>
							</b-dropdown-item>
							<b-dropdown-item href="#">
								<router-link :to="{path: '/settings/emailTemplates', params: {page: 'emailTemplates'}}">
									<img src="https://old.ohmylead.com/assets/new/images/menu/email-black.svg">
									<div class="shortcut-menu-item-inner">
										Email Template
										<span>Add a new email template</span>
									</div>
								</router-link>
							</b-dropdown-item>
						</b-dropdown-->
						
					</div>
					
					<!--div class=" my-auto">
						<b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret class="dropdown-md">
							<template v-slot:button-content>
								<span><flag :iso="userLanguage.flag" v-bind:squared=false /> {{ userLanguage.title }}</span>
							</template>
							<b-dropdown-item href="#" v-for="entry in languages" :key="entry.title" @click="changeLocale(entry)">
								<flag :iso="entry.flag" v-bind:squared=false /> {{entry.title}}
							</b-dropdown-item>
							
						</b-dropdown>
					</div-->
					
					<div class="border-right border-left profil text-center my-auto" style="padding-top: 11px;padding-bottom: 11px;">
						
						<b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret class="login-user-md" right>
							<template v-slot:button-content>
								<div class="dropdown-toggle d-flex" style="color: #4a4a4a;">
									<!--  class="thumb-sm avatar pull-left m-t-n-xs" -->
									<user-avatar v-if="check_avatar == ''" :fullname="fullname" :size="38"></user-avatar>
									<img v-else :src="`img/Avatar/${check_avatar}`" class="img-md-profil" />
									<div style="font-size: 14px;padding: 10px 15px;"> {{ fullname }} </div>
									<div style="padding: 6px 0px;"><i class="fa fa-caret-down" style="vertical-align: bottom;"></i></div>
								</div>
							</template>
							
								<b-dropdown-item href="#" v-if="!$store.state.WhiteLabel || $store.state.IsAdmin">
									<div >
									<div class="item-content-md">
										<div style=" display: inline-block; width: 74%; vertical-align: top; ">
											<p class="progress-bar-head">{{ $t('YouHave') }}  {{ leadsCountNav }} / {{ maxLeadsPlans }} {{ $t('Leads') }}</p>
											<p class="progress-bar-subhead">{{ $t('PlanInUse') }} : <b>{{ namePlans }}</b></p>
										</div>
										<div style=" display: inline-block; width: 30%; ">
											<progress-bar :percentage="percentage"></progress-bar>
										</div>
									</div>
									</div>
								</b-dropdown-item>
							
							
							<!--b-dropdown-item :to="{path: '/settings/profile', params: {page: 'profile'}}" class="item-content-md" @click="$store.state.selectedPage = 'profile'"><span>Profile <i class="fa fa-user"></i></span></b-dropdown-item-->
							<!--b-dropdown-item :to="{path: '/settings/plan', params: {page: 'plan'}}" class="item-content-md"><span>Plan <i class="fa fa-credit-card"></i></span></b-dropdown-item-->
							<b-dropdown-item :to="{ path: '/account/profile' }" class="item-content-md" @click="$store.state.selectedPage = 'profile'"><span>{{ $t('ProfileSettings') }} <i class="fa fa-user"></i></span></b-dropdown-item>
							
							<!--template v-if="namePlans == 'Agency'">
								<b-dropdown-item class="item-content-md" @click="$bvModal.show('modal-profile-setting')">
									<span>{{ $t('WhiteLabel') }} <i class="fa fa-tags"></i></span>
								</b-dropdown-item>
							</template-->
							
							<b-dropdown-item :to="{path: '/settings/clients', params: {page: 'clients'}}" class="item-content-md" @click="$store.state.selectedPage = 'clients'"><span>{{ $t('WorkspaceSettings') }} <i class="fa fa-street-view"></i></span></b-dropdown-item>
							<template v-if="!$store.state.WhiteLabel || $store.state.IsAdmin">
								<b-dropdown-item class="item-content-md" @click="CheckWhiteLabel"><span>{{ $t('WhiteLabel') }} <i class="fa fa-tags"></i></span></b-dropdown-item>
							</template>
							<!--b-dropdown-item :to="{path: '/settings/team', params: {page: 'team'}}" class="item-content-md" @click="$store.state.selectedPage = 'team'"><span>Team <i class="fa fa-users"></i></span></b-dropdown-item-->
							<!--b-dropdown-item :to="{path: '/settings/emailTemplates', params: {page: 'emailTemplates'}}" class="item-content-md"><span>Email Templates <i class="fa fa-envelope"></i></span></b-dropdown-item-->
							<!--template v-if="!$store.state.WhiteLabel || $store.state.IsAdmin">
								<b-dropdown-item  href="https://intercom.help/ohmylead-0328294f6b39/en/" target="_blank" class="item-content-md">
									<span>{{ $t('HelpCenter') }} <i class="fa fa-question-circle"></i></span>
								</b-dropdown-item>
							</template-->
							<b-dropdown-item href="#" @click.prevent="logout()" class="item-content-md"><span>{{ $t('Logout') }} <i class="fa fa-sign-out"></i></span></b-dropdown-item>
							<template v-if="!$store.state.WhiteLabel || $store.state.IsAdmin">
								<b-dropdown-text class="item-content-md">
									<button  class="btn btn-warning btn-block" @click="$bvModal.show('modal-plans')" style="color: #fff;">{{ $t('Upgrade') }}</button>
								</b-dropdown-text>
							</template>
							<!-- $auth.logout() -->
						</b-dropdown>
						
					</div>
					<!--div @click="rightBarToggle = !rightBarToggle" :style="{ backgroundColor: rightBarToggle ? 'rgb(240, 248, 255)' : '#fff', cursor: 'pointer' }" class="col-1 text-center pl-0 pr-0 pt-1">
						<progress-bar :percentage="28"></progress-bar>
						<center class="svg-span">Get started</center>
					</div-->
				</div>
				
				<b-modal id="modal-add-client" centered size="md">
					<template v-slot:modal-title>{{ $t('AddWorkspace') }}</template>
					<div>
						<div class="form-group row">
							<div class="col-12">
								<label class="m-0 default-label">{{ $t('Name') }}</label>
								<div class="input-group">
									<div class="input-group-prepend">
										<div class="input-group-text bg-white border-right-0"><i class="fa fa-street-view"></i></div>
									</div>
									<input type="text" class="form-control " :placeholder="$t('TypeYourWorkspaceName')" v-model="clientArray.name" />
								</div>
								<small class="help-text text-danger" v-if="is_empty"> * {{ $t('TypeYourWorkspaceName') }}</small>
							</div>
						</div>
						
						<div class="form-group row">
							<div class="col-12">
								<label class="m-0 default-label">{{ $t('Timezone') }}</label>
								<drop-options v-model="clientArray.timezone" label="Timezone" :options="timezones" max-width fa-icon="fa-clock-o"></drop-options>
								<small class="help-text">{{ $t('TheTimezoneToBeUsedInThisWorkspace') }}.</small>
							</div>
						</div>
						
						<div class="form-group row">
							<div class="col-md-12">
								<label class="m-0 default-label">{{ $t('Country') }}</label>
								<drop-options v-model="clientArray.country_code" label="Country" :options="CountryOptions" max-width fa-icon="fa-flag-o"></drop-options>
								<small class="help-text">{{ $t('CountryDesc') }}</small>
							</div>
						</div>
						
					</div>
					<template v-slot:modal-footer>
						<b-button @click="addClient()" variant="primary">
							<i class="fa fa-spinner fa-spin" v-if="loadingAction"></i>
							<i class="fa fa-plus" v-else></i>
							{{ $t('AddWorkspace') }}
						</b-button>
					</template>
				</b-modal>
				
				<b-modal id="modal-check-access" centered size="md" hide-footer hide-header>
					<div class="upgrade-div">
						<img src="/img/svg/times.svg" @click="$bvModal.hide('modal-check-access')" class="pull-right c-pointer" />
						
						<div class="text-center">
							<img src="/img/upgrade.png" class="upgrade-img mt-5" />
							<p class="px-5 p-upgrade">{{ $t('UpgradeDesc') }}</p>
							<!--div><button @click="SeePlans" class="btn btn-outline-upgrade btn-upgrade-size">SEE PRICING & PLANS</button></div-->
							<div>
								<button @click="SeePlans" class="btn btn-upgrade btn-upgrade-size">
									<img src="/img/upgrade-icon.png" /> {{ $t('UpgradeButton') }}
								</button>
							</div>
						</div>
					</div>
				</b-modal>
				
				<b-modal id="modal-list-clients" centered scrollable size="max" hide-footer hide-header no-close-on-backdrop>
					<div class="pt-3 pb-5">
						<i class="fa fa-close close-icon" @click="closeModalClient"></i>
						<list-clients></list-clients>
					</div>
				</b-modal>
				
				<b-modal id="modal-plans" centered scrollable size="lg" hide-footer hide-header>
					<div class="pt-3 pb-5">
						<i class="fa fa-close close-icon" @click="$bvModal.hide('modal-plans')"></i>
						<plan></plan>
					</div>
				</b-modal>
				
				<b-modal id="modal-mobile" centered scrollable size="lg" hide-footer hide-header  no-close-on-backdrop v-if="!isWhiteLabel && $cookies.get('demoModal') != 'false'">
					<div class="px-5 pt-5 text-center"><a style="float: right;font-size: 17px;line-height: 65px;text-decoration: underline;cursor: pointer;position: absolute;right: 50px;top: 0px;font-size: 20px;" @click="$bvModal.hide('modal-mobile')"><i class="fa fa-times"></i> </a>
						<div style="font-size: 13px;
                color: #ff5757;
                font-weight: bold;
                text-transform: uppercase;
                letter-spacing: 1px;
                margin-bottom: 5px;text-align:center">  👋 {{ $t('newOML') }}</div>
				<h2 class="get-started">{{ $t('singleSource') }}	</h2><br>
						<center>
								<div class="wistia_responsive_padding" style="padding:62.5% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_tuw4n17upk videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/tuw4n17upk/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>
						</center>
						<br>
						<div>
						<h3 class="get-started ">{{ $t('stillHaveQuestion') }}</h3>
						<a style="color:#fff" onclick="Calendly.showPopupWidget('https://calendly.com/oml-support/1-on-1-demo-ohmylead');return false;"  href="#" class="get-started-btn"> {{ $t('bookFree') }}</a>
						<p><a @click="doNotShowItAgain()" style=" font-size: 13px; cursor: pointer;  color: #000;    text-decoration: underline;">Don't show me this again</a></p>
						
						</div>
						
						
					</div>
				</b-modal>
				
				<!--b-modal id="modal-black-friday" centered size="md" hide-footer hide-header v-model="$store.state.BlackFriday">
					<div class="upgrade-el">
						<i class="fa fa-close pull-right c-pointer" style=" top: 20px; position: absolute; right: 20px; " @click="$store.state.BlackFriday = false"></i>
						
						<div class="text-center">
							<h3 class="mt-5">DON'T MISS OUT ON OUR EXCLUSIVE BLACK FRIDAY DEAL</h3>
							<img src="/img/icon/black_friday.jpg" class="upgrade-img" style="width: 10em;" />
							<div class="mb-3">
								<p class="px-5 p-upgrade">Get FLAT 50% OFF on all of our Annual Plans.</p>
								<p class="px-5 p-upgrade">Use the coupon <b>BLACKFRIDAY</b></p>
							</div>
							<div>
								<button class="btn btn-upgrade btn-upgrade-size" @click="$store.state.BlackFriday = false, $bvModal.show('modal-plans'), $store.state.planInterval = 'yearly'">
									Grab the deal
								</button>
							</div>
						</div>
					</div>
				</b-modal-->
				
				<div :class="[ 'sidebar', rightBarToggle ? 'active' : '' ]">
					
					<div id="get-started-panel">
						<h3 style="color: #394e7e; margin-bottom: 3rem;">You're almost there</h3>
						<div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
							<div class="panel panel-default done">
								<div class="panel-heading" role="tab" id="headingOne">
									<h4 class="panel-title">
										<a>
											<i class="fa fa-check-circle"></i> 1. Confirm your email address
										</a>
									</h4>
								</div>
							</div>
							<div class="panel panel-default ">
								<div class="panel-heading" role="tab" id="headingTwo">
									<h4 class="panel-title">
										<a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
											<i class="fa fa-check-circle"></i> 2. Connect your first leads source
										</a>
									</h4>
								</div>
								<div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
									<div class="panel-body">
										Make the most of your lead generation campaigns by gathering and managing every source in one unique place.
										<a href="" style="color: #377cff; margin-top: 1rem; display: block;">Connect your lead sources</a>
									</div>
								</div>
							</div>
							<div class="panel panel-default ">
								<div class="panel-heading" role="tab" id="headingThree">
									<h4 class="panel-title">
										<a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
											<i class="fa fa-check-circle"></i> 3. Synchronize your favorite CRM
										</a>
									</h4>
								</div>
								<div id="collapseThree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
									<div class="panel-body">
										Send automatically your sales ready leads to your CRM in real time.
										<a href="" style="color: #377cff; margin-top: 1rem; display: block;">Connect your CRM</a>
									</div>
								</div>
							</div>
							<div class="panel panel-default ">
								<div class="panel-heading" role="tab" id="headingThree">
									<h4 class="panel-title">
										<a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
											<i class="fa fa-check-circle"></i> 4. Configure your Email Marketing Tool
										</a>
									</h4>
								</div>
								<div id="collapseFour" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
									<div class="panel-body">
										Nurture and Grow your leads by setting up an automatic export according to specific status.
										<a href="" style="color: #377cff; margin-top: 1rem; display: block;">Configure your ESP</a>
									</div>
								</div>
							</div>
							<div class="panel panel-default ">
								<div class="panel-heading" role="tab" id="hasCommunication">
									<h4 class="panel-title">
										<a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
											<i class="fa fa-check-circle"></i> 5. Connect your Call / Sms tool
										</a>
									</h4>
								</div>
							</div>
							<div class="panel panel-default ">
								<div class="panel-heading" role="tab" id="hasEnrichment">
									<h4 class="panel-title">
										<a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseSix" aria-expanded="true" aria-controls="collapseFive">
											<i class="fa fa-check-circle"></i> 6. Connect your lead enrichment Tool
										</a>
									</h4>
								</div>
							</div>
							<div class="panel panel-default done">
								<div class="panel-heading" role="tab" id="headingThree">
									<h4 class="panel-title">
										<a>
											<i class="fa fa-check-circle"></i> 7. Invite your team members
										</a>
									</h4>
								</div>
							</div>
						</div>
						<!--div class="get-started-footer">
							<a href="?completed=true">Don't show this again</a>
							<a href="https://intercom.help/ohmylead-0328294f6b39/en/" target="_blank">Help Center</a>
						</div-->
					</div>
					
				</div>
				
				<div :class="[ 'overlay', rightBarToggle ? 'active' : '' ]" @click="rightBarToggle = false"></div>
				
			</div>
		</div>
	</header>
</template>

<script>
	import progressBar 	from '@/plugins/md/progressBar.vue'
	import userAvatar 	from '@/plugins/md/Avatar.vue'
	import multiSelect 	from '@/plugins/md/multiselect/select-dropdown.vue'
	import DropOptions	from "@/components/DropOptions.vue";
	import ListClients 	from '@/views/user/settings/ListClients'
	import plan		   	from '@/views/user/settings/plan'
	
	import i18n from '@/config/i18n';
	export default {
		components: {
			progressBar,
			userAvatar,
			multiSelect,
			ListClients,
			DropOptions,
			plan
		},
		data() {
			return {
				userLanguage: { title : 'English', flag : 'us' },
				languages	: [
					{ flag: 'us', language: 'en', title: 'English' },
					{ flag: 'fr', language: 'fr', title: 'français' },
					// { flag: 'es', language: 'es', title: 'Español' }
				],
				
				clientName		: '',
				is_empty		: false,
				loadingAction	: false,
				
				rightBarToggle	: false,
				
				namePlans 		: '',
				maxLeadsPlans	: 0,
				leadsCountNav	: 0,
				percentage		: 0,
				isWhiteLabel  : false,
				// myTeams 		: [],
				
				clientArray		: { name:'', country_code:'', timezone:'' },
				
				countryList		: [
					{ id: 'AD', title: 'ANDORRA', code: '376'}, { id: 'AE', title: 'UNITED ARAB EMIRATES', code: '971'}, { id: 'AF', title: 'AFGHANISTAN', code: '93'}, { id: 'AG', title: 'ANTIGUA AND BARBUDA', code: '1268'}, { id: 'AI', title: 'ANGUILLA', code: '1264'}, { id: 'AL', title: 'ALBANIA', code: '355'}, { id: 'AM', title: 'ARMENIA', code: '374'}, { id: 'AN', title: 'NETHERLANDS ANTILLES', code: '599'}, { id: 'AO', title: 'ANGOLA', code: '244'}, { id: 'AQ', title: 'ANTARCTICA', code: '672'}, { id: 'AR', title: 'ARGENTINA', code: '54'}, { id: 'AS', title: 'AMERICAN SAMOA', code: '1684'}, { id: 'AT', title: 'AUSTRIA', code: '43'}, { id: 'AU', title: 'AUSTRALIA', code: '61'}, { id: 'AW', title: 'ARUBA', code: '297'}, { id: 'AZ', title: 'AZERBAIJAN', code: '994'}, { id: 'BA', title: 'BOSNIA AND HERZEGOVINA', code: '387'}, { id: 'BB', title: 'BARBADOS', code: '1246'}, { id: 'BD', title: 'BANGLADESH', code: '880'}, { id: 'BE', title: 'BELGIUM', code: '32'}, { id: 'BF', title: 'BURKINA FASO', code: '226'}, { id: 'BG', title: 'BULGARIA', code: '359'}, { id: 'BH', title: 'BAHRAIN', code: '973'}, { id: 'BI', title: 'BURUNDI', code: '257'}, { id: 'BJ', title: 'BENIN', code: '229'}, { id: 'BL', title: 'SAINT BARTHELEMY', code: '590'}, { id: 'BM', title: 'BERMUDA', code: '1441'}, { id: 'BN', title: 'BRUNEI DARUSSALAM', code: '673'}, { id: 'BO', title: 'BOLIVIA', code: '591'}, { id: 'BR', title: 'BRAZIL', code: '55'}, { id: 'BS', title: 'BAHAMAS', code: '1242'}, { id: 'BT', title: 'BHUTAN', code: '975'}, { id: 'BW', title: 'BOTSWANA', code: '267'}, { id: 'BY', title: 'BELARUS', code: '375'}, { id: 'BZ', title: 'BELIZE', code: '501'}, { id: 'CA', title: 'CANADA', code: '1'}, { id: 'CC', title: 'COCOS (KEELING) ISLANDS', code: '61'}, { id: 'CD', title: 'CONGO, THE DEMOCRATIC REPUBLIC OF THE', code: '243'}, { id: 'CF', title: 'CENTRAL AFRICAN REPUBLIC', code: '236'}, { id: 'CG', title: 'CONGO', code: '242'}, { id: 'CH', title: 'SWITZERLAND', code: '41'}, { id: 'CI', title: 'COTE D IVOIRE', code: '225'}, { id: 'CK', title: 'COOK ISLANDS', code: '682'}, { id: 'CL', title: 'CHILE', code: '56'}, { id: 'CM', title: 'CAMEROON', code: '237'}, { id: 'CN', title: 'CHINA', code: '86'}, { id: 'CO', title: 'COLOMBIA', code: '57'}, { id: 'CR', title: 'COSTA RICA', code: '506'}, { id: 'CU', title: 'CUBA', code: '53'}, { id: 'CV', title: 'CAPE VERDE', code: '238'}, { id: 'CX', title: 'CHRISTMAS ISLAND', code: '61'}, { id: 'CY', title: 'CYPRUS', code: '357'}, { id: 'CZ', title: 'CZECH REPUBLIC', code: '420'}, { id: 'DE', title: 'GERMANY', code: '49'}, { id: 'DJ', title: 'DJIBOUTI', code: '253'}, { id: 'DK', title: 'DENMARK', code: '45'}, { id: 'DM', title: 'DOMINICA', code: '1767'}, { id: 'DO', title: 'DOMINICAN REPUBLIC', code: '1809'}, { id: 'DZ', title: 'ALGERIA', code: '213'}, { id: 'EC', title: 'ECUADOR', code: '593'}, { id: 'EE', title: 'ESTONIA', code: '372'}, { id: 'EG', title: 'EGYPT', code: '20'}, { id: 'ER', title: 'ERITREA', code: '291'}, { id: 'ES', title: 'SPAIN', code: '34'}, { id: 'ET', title: 'ETHIOPIA', code: '251'}, { id: 'FI', title: 'FINLAND', code: '358'}, { id: 'FJ', title: 'FIJI', code: '679'}, { id: 'FK', title: 'FALKLAND ISLANDS (MALVINAS)', code: '500'}, { id: 'FM', title: 'MICRONESIA, FEDERATED STATES OF', code: '691'}, { id: 'FO', title: 'FAROE ISLANDS', code: '298'}, { id: 'FR', title: 'FRANCE', code: '33'}, { id: 'GA', title: 'GABON', code: '241'}, { id: 'GB', title: 'UNITED KINGDOM', code: '44'}, { id: 'GD', title: 'GRENADA', code: '1473'}, { id: 'GE', title: 'GEORGIA', code: '995'}, { id: 'GH', title: 'GHANA', code: '233'}, { id: 'GI', title: 'GIBRALTAR', code: '350'}, { id: 'GL', title: 'GREENLAND', code: '299'}, { id: 'GM', title: 'GAMBIA', code: '220'}, { id: 'GN', title: 'GUINEA', code: '224'}, { id: 'GQ', title: 'EQUATORIAL GUINEA', code: '240'}, { id: 'GR', title: 'GREECE', code: '30'}, { id: 'GT', title: 'GUATEMALA', code: '502'}, { id: 'GU', title: 'GUAM', code: '1671'}, { id: 'GW', title: 'GUINEA-BISSAU', code: '245'}, { id: 'GY', title: 'GUYANA', code: '592'}, { id: 'HK', title: 'HONG KONG', code: '852'}, { id: 'HN', title: 'HONDURAS', code: '504'}, { id: 'HR', title: 'CROATIA', code: '385'}, { id: 'HT', title: 'HAITI', code: '509'}, { id: 'HU', title: 'HUNGARY', code: '36'}, { id: 'ID', title: 'INDONESIA', code: '62'}, { id: 'IE', title: 'IRELAND', code: '353'}, { id: 'IL', title: 'ISRAEL', code: '972'}, { id: 'IM', title: 'ISLE OF MAN', code: '44'}, { id: 'IN', title: 'INDIA', code: '91'}, { id: 'IQ', title: 'IRAQ', code: '964'}, { id: 'IR', title: 'IRAN, ISLAMIC REPUBLIC OF', code: '98'}, { id: 'IS', title: 'ICELAND', code: '354'}, { id: 'IT', title: 'ITALY', code: '39'}, { id: 'JM', title: 'JAMAICA', code: '1876'}, { id: 'JO', title: 'JORDAN', code: '962'}, { id: 'JP', title: 'JAPAN', code: '81'}, { id: 'KE', title: 'KENYA', code: '254'}, { id: 'KG', title: 'KYRGYZSTAN', code: '996'}, { id: 'KH', title: 'CAMBODIA', code: '855'}, { id: 'KI', title: 'KIRIBATI', code: '686'}, { id: 'KM', title: 'COMOROS', code: '269'}, { id: 'KN', title: 'SAINT KITTS AND NEVIS', code: '1869'}, { id: 'KP', title: 'KOREA DEMOCRATIC PEOPLES REPUBLIC OF', code: '850'}, { id: 'KR', title: 'KOREA REPUBLIC OF', code: '82'}, { id: 'KW', title: 'KUWAIT', code: '965'}, { id: 'KY', title: 'CAYMAN ISLANDS', code: '1345'}, { id: 'KZ', title: 'KAZAKSTAN', code: '7'}, { id: 'LA', title: 'LAO PEOPLES DEMOCRATIC REPUBLIC', code: '856'}, { id: 'LB', title: 'LEBANON', code: '961'}, { id: 'LC', title: 'SAINT LUCIA', code: '1758'}, { id: 'LI', title: 'LIECHTENSTEIN', code: '423'}, { id: 'LK', title: 'SRI LANKA', code: '94'}, { id: 'LR', title: 'LIBERIA', code: '231'}, { id: 'LS', title: 'LESOTHO', code: '266'}, { id: 'LT', title: 'LITHUANIA', code: '370'}, { id: 'LU', title: 'LUXEMBOURG', code: '352'}, { id: 'LV', title: 'LATVIA', code: '371'}, { id: 'LY', title: 'LIBYAN ARAB JAMAHIRIYA', code: '218'}, { id: 'MA', title: 'MOROCCO', code: '212'}, { id: 'MC', title: 'MONACO', code: '377'}, { id: 'MD', title: 'MOLDOVA, REPUBLIC OF', code: '373'}, { id: 'ME', title: 'MONTENEGRO', code: '382'}, { id: 'MF', title: 'SAINT MARTIN', code: '1599'}, { id: 'MG', title: 'MADAGASCAR', code: '261'}, { id: 'MH', title: 'MARSHALL ISLANDS', code: '692'}, { id: 'MK', title: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF', code: '389'}, { id: 'ML', title: 'MALI', code: '223'}, { id: 'MM', title: 'MYANMAR', code: '95'}, { id: 'MN', title: 'MONGOLIA', code: '976'}, { id: 'MO', title: 'MACAU', code: '853'}, { id: 'MP', title: 'NORTHERN MARIANA ISLANDS', code: '1670'}, { id: 'MR', title: 'MAURITANIA', code: '222'}, { id: 'MS', title: 'MONTSERRAT', code: '1664'}, { id: 'MT', title: 'MALTA', code: '356'}, { id: 'MU', title: 'MAURITIUS', code: '230'}, { id: 'MV', title: 'MALDIVES', code: '960'}, { id: 'MW', title: 'MALAWI', code: '265'}, { id: 'MX', title: 'MEXICO', code: '52'}, { id: 'MY', title: 'MALAYSIA', code: '60'}, { id: 'MZ', title: 'MOZAMBIQUE', code: '258'}, { id: 'NA', title: 'NAMIBIA', code: '264'}, { id: 'NC', title: 'NEW CALEDONIA', code: '687'}, { id: 'NE', title: 'NIGER', code: '227'}, { id: 'NG', title: 'NIGERIA', code: '234'}, { id: 'NI', title: 'NICARAGUA', code: '505'}, { id: 'NL', title: 'NETHERLANDS', code: '31'}, { id: 'NO', title: 'NORWAY', code: '47'}, { id: 'NP', title: 'NEPAL', code: '977'}, { id: 'NR', title: 'NAURU', code: '674'}, { id: 'NU', title: 'NIUE', code: '683'}, { id: 'NZ', title: 'NEW ZEALAND', code: '64'}, { id: 'OM', title: 'OMAN', code: '968'}, { id: 'PA', title: 'PANAMA', code: '507'}, { id: 'PE', title: 'PERU', code: '51'}, { id: 'PF', title: 'FRENCH POLYNESIA', code: '689'}, { id: 'PG', title: 'PAPUA NEW GUINEA', code: '675'}, { id: 'PH', title: 'PHILIPPINES', code: '63'}, { id: 'PK', title: 'PAKISTAN', code: '92'}, { id: 'PL', title: 'POLAND', code: '48'}, { id: 'PM', title: 'SAINT PIERRE AND MIQUELON', code: '508'}, { id: 'PN', title: 'PITCAIRN', code: '870'}, { id: 'PR', title: 'PUERTO RICO', code: '1'}, { id: 'PT', title: 'PORTUGAL', code: '351'}, { id: 'PW', title: 'PALAU', code: '680'}, { id: 'PY', title: 'PARAGUAY', code: '595'}, { id: 'QA', title: 'QATAR', code: '974'}, { id: 'RO', title: 'ROMANIA', code: '40'}, { id: 'RS', title: 'SERBIA', code: '381'}, { id: 'RU', title: 'RUSSIAN FEDERATION', code: '7'}, { id: 'RW', title: 'RWANDA', code: '250'}, { id: 'SA', title: 'SAUDI ARABIA', code: '966'}, { id: 'SB', title: 'SOLOMON ISLANDS', code: '677'}, { id: 'SC', title: 'SEYCHELLES', code: '248'}, { id: 'SD', title: 'SUDAN', code: '249'}, { id: 'SE', title: 'SWEDEN', code: '46'}, { id: 'SG', title: 'SINGAPORE', code: '65'}, { id: 'SH', title: 'SAINT HELENA', code: '290'}, { id: 'SI', title: 'SLOVENIA', code: '386'}, { id: 'SK', title: 'SLOVAKIA', code: '421'}, { id: 'SL', title: 'SIERRA LEONE', code: '232'}, { id: 'SM', title: 'SAN MARINO', code: '378'}, { id: 'SN', title: 'SENEGAL', code: '221'}, { id: 'SO', title: 'SOMALIA', code: '252'}, { id: 'SR', title: 'SURINAME', code: '597'}, { id: 'ST', title: 'SAO TOME AND PRINCIPE', code: '239'}, { id: 'SV', title: 'EL SALVADOR', code: '503'}, { id: 'SY', title: 'SYRIAN ARAB REPUBLIC', code: '963'}, { id: 'SZ', title: 'SWAZILAND', code: '268'}, { id: 'TC', title: 'TURKS AND CAICOS ISLANDS', code: '1649'}, { id: 'TD', title: 'CHAD', code: '235'}, { id: 'TG', title: 'TOGO', code: '228'}, { id: 'TH', title: 'THAILAND', code: '66'}, { id: 'TJ', title: 'TAJIKISTAN', code: '992'}, { id: 'TK', title: 'TOKELAU', code: '690'}, { id: 'TL', title: 'TIMOR-LESTE', code: '670'}, { id: 'TM', title: 'TURKMENISTAN', code: '993'}, { id: 'TN', title: 'TUNISIA', code: '216'}, { id: 'TO', title: 'TONGA', code: '676'}, { id: 'TR', title: 'TURKEY', code: '90'}, { id: 'TT', title: 'TRINIDAD AND TOBAGO', code: '1868'}, { id: 'TV', title: 'TUVALU', code: '688'}, { id: 'TW', title: 'TAIWAN, PROVINCE OF CHINA', code: '886'}, { id: 'TZ', title: 'TANZANIA, UNITED REPUBLIC OF', code: '255'}, { id: 'UA', title: 'UKRAINE', code: '380'}, { id: 'UG', title: 'UGANDA', code: '256'}, { id: 'US', title: 'UNITED STATES', code: '1'}, { id: 'UY', title: 'URUGUAY', code: '598'}, { id: 'UZ', title: 'UZBEKISTAN', code: '998'}, { id: 'VA', title: 'HOLY SEE (VATICAN CITY STATE)', code: '39'}, { id: 'VC', title: 'SAINT VINCENT AND THE GRENADINES', code: '1784'}, { id: 'VE', title: 'VENEZUELA', code: '58'}, { id: 'VG', title: 'VIRGIN ISLANDS, BRITISH', code: '1284'}, { id: 'VI', title: 'VIRGIN ISLANDS, U.S.', code: '1340'}, { id: 'VN', title: 'VIET NAM', code: '84'}, { id: 'VU', title: 'VANUATU', code: '678'}, { id: 'WF', title: 'WALLIS AND FUTUNA', code: '681'}, { id: 'WS', title: 'SAMOA', code: '685'}, { id: 'XK', title: 'KOSOVO', code: '381'}, { id: 'YE', title: 'YEMEN', code: '967'}, { id: 'YT', title: 'MAYOTTE', code: '262'}, { id: 'ZA', title: 'SOUTH AFRICA', code: '27'}, { id: 'ZM', title: 'ZAMBIA', code: '260'}, { id: 'ZW', title: 'ZIMBABWE', code: '263'}
				],
				CountryOptions	: [],
				timezones		: [
					{ id: 'Africa/Abidjan', title : 'Africa/Abidjan' }, { id: 'Africa/Accra', title : 'Africa/Accra' }, { id: 'Africa/Addis_Ababa', title : 'Africa/Addis Ababa' }, { id: 'Africa/Algiers', title : 'Africa/Algiers' }, { id: 'Africa/Asmara', title : 'Africa/Asmara' }, { id: 'Africa/Bamako', title : 'Africa/Bamako' }, { id: 'Africa/Bangui', title : 'Africa/Bangui' }, { id: 'Africa/Banjul', title : 'Africa/Banjul' }, { id: 'Africa/Bissau', title : 'Africa/Bissau' }, { id: 'Africa/Blantyre', title : 'Africa/Blantyre' }, { id: 'Africa/Brazzaville', title : 'Africa/Brazzaville' }, { id: 'Africa/Bujumbura', title : 'Africa/Bujumbura' }, { id: 'Africa/Cairo', title : 'Africa/Cairo' }, { id: 'Africa/Casablanca', title : 'Africa/Casablanca' }, { id: 'Africa/Ceuta', title : 'Africa/Ceuta' }, { id: 'Africa/Conakry', title : 'Africa/Conakry' }, { id: 'Africa/Dakar', title : 'Africa/Dakar' }, { id: 'Africa/Dar_es_Salaam', title : 'Africa/Dar es Salaam' }, { id: 'Africa/Djibouti', title : 'Africa/Djibouti' }, { id: 'Africa/Douala', title : 'Africa/Douala' }, { id: 'Africa/El_Aaiun', title : 'Africa/El_Aaiun' }, { id: 'Africa/Freetown', title : 'Africa/Freetown' }, { id: 'Africa/Gaborone', title : 'Africa/Gaborone' }, { id: 'Africa/Harare', title : 'Africa/Harare' }, { id: 'Africa/Johannesburg', title : 'Africa/Johannesburg' }, { id: 'Africa/Kampala', title : 'Africa/Kampala' }, { id: 'Africa/Khartoum', title : 'Africa/Khartoum' }, { id: 'Africa/Kigali', title : 'Africa/Kigali' }, { id: 'Africa/Kinshasa', title : 'Africa/Kinshasa' }, { id: 'Africa/Lagos', title : 'Africa/Lagos' }, { id: 'Africa/Libreville', title : 'Africa/Libreville' }, { id: 'Africa/Lome', title : 'Africa/Lome' }, { id: 'Africa/Luanda', title : 'Africa/Luanda' }, { id: 'Africa/Lubumbashi', title : 'Africa/Lubumbashi' }, { id: 'Africa/Lusaka', title : 'Africa/Lusaka' }, { id: 'Africa/Malabo', title : 'Africa/Malabo' }, { id: 'Africa/Maputo', title : 'Africa/Maputo' }, { id: 'Africa/Maseru', title : 'Africa/Maseru' }, { id: 'Africa/Mbabane', title : 'Africa/Mbabane' }, { id: 'Africa/Mogadishu', title : 'Africa/Mogadishu' }, { id: 'Africa/Monrovia', title : 'Africa/Monrovia' }, { id: 'Africa/Nairobi', title : 'Africa/Nairobi' }, { id: 'Africa/Ndjamena', title : 'Africa/Ndjamena' }, { id: 'Africa/Niamey', title : 'Africa/Niamey' }, { id: 'Africa/Nouakchott', title : 'Africa/Nouakchott' }, { id: 'Africa/Ouagadougou', title : 'Africa/Ouagadougou' }, { id: 'Africa/Porto-Novo', title : 'Africa/Porto-Novo' }, { id: 'Africa/Sao_Tome', title : 'Africa/Sao Tome' }, { id: 'Africa/Tripoli', title : 'Africa/Tripoli' }, { id: 'Africa/Tunis', title : 'Africa/Tunis' }, { id: 'Africa/Windhoek', title : 'Africa/Windhoek' },
					{ id: 'America/Adak', title : 'America/Adak' }, { id: 'America/Anchorage', title : 'America/Anchorage' }, { id: 'America/Anguilla', title : 'America/Anguilla' }, { id: 'America/Antigua', title : 'America/Antigua' }, { id: 'America/Araguaina', title : 'America/Araguaina' }, { id: 'America/Argentina/Buenos_Aires', title : 'America/Argentina/Buenos Aires' }, { id: 'America/Argentina/Catamarca', title : 'America/Argentina/Catamarca' }, { id: 'America/Argentina/Cordoba', title : 'America/Argentina/Cordoba' }, { id: 'America/Argentina/Jujuy', title : 'America/Argentina/Jujuy' }, { id: 'America/Argentina/La_Rioja', title : 'America/Argentina/La Rioja' }, { id: 'America/Argentina/Mendoza', title : 'America/Argentina/Mendoza' }, { id: 'America/Argentina/Rio_Gallegos', title : 'America/Argentina/Rio Gallegos' }, { id: 'America/Argentina/Salta', title : 'America/Argentina/Salta' }, { id: 'America/Argentina/San_Juan', title : 'America/Argentina/San Juan' }, { id: 'America/Argentina/San_Luis', title : 'America/Argentina/San Luis' }, { id: 'America/Argentina/Tucuman', title : 'America/Argentina/Tucuman' }, { id: 'America/Argentina/Ushuaia', title : 'America/Argentina/Ushuaia' }, { id: 'America/Aruba', title : 'America/Aruba' }, { id: 'America/Asuncion', title : 'America/Asuncion' }, { id: 'America/Atikokan', title : 'America/Atikokan' }, { id: 'America/Bahia', title : 'America/Bahia' }, { id: 'America/Bahia_Banderas', title : 'America/Bahia Banderas' }, { id: 'America/Barbados', title : 'America/Barbados' }, { id: 'America/Belem', title : 'America/Belem' }, { id: 'America/Belize', title : 'America/Belize' }, { id: 'America/Blanc-Sablon', title : 'America/Blanc-Sablon' }, { id: 'America/Boa_Vista', title : 'America/Boa Vista' }, { id: 'America/Bogota', title : 'America/Bogota' }, { id: 'America/Boise', title : 'America/Boise' }, { id: 'America/Cambridge_Bay', title : 'America/Cambridge Bay' }, { id: 'America/Campo_Grande', title : 'America/Campo Grande' }, { id: 'America/Cancun', title : 'America/Cancun' }, { id: 'America/Caracas', title : 'America/Caracas' }, { id: 'America/Cayenne', title : 'America/Cayenne' }, { id: 'America/Cayman', title : 'America/Cayman' }, { id: 'America/Chicago', title : 'America/Chicago' }, { id: 'America/Chihuahua', title : 'America/Chihuahua' }, { id: 'America/Costa_Rica', title : 'America/Costa Rica' }, { id: 'America/Cuiaba', title : 'America/Cuiaba' }, { id: 'America/Curacao', title : 'America/Curacao' }, { id: 'America/Danmarkshavn', title : 'America/Danmarkshavn' }, { id: 'America/Dawson', title : 'America/Dawson' }, { id: 'America/Dawson_Creek', title : 'America/Dawson Creek' }, { id: 'America/Denver', title : 'America/Denver' }, { id: 'America/Detroit', title : 'America/Detroit' }, { id: 'America/Dominica', title : 'America/Dominica' }, { id: 'America/Edmonton', title : 'America/Edmonton' }, { id: 'America/Eirunepe', title : 'America/Eirunepe' }, { id: 'America/El_Salvador', title : 'America/El Salvador' }, { id: 'America/Fortaleza', title : 'America/Fortaleza' }, { id: 'America/Glace_Bay', title : 'America/Glace Bay' }, { id: 'America/Godthab', title : 'America/Godthab' }, { id: 'America/Goose_Bay', title : 'America/Goose Bay' }, { id: 'America/Grand_Turk', title : 'America/Grand Turk' }, { id: 'America/Grenada', title : 'America/Grenada' }, { id: 'America/Guadeloupe', title : 'America/Guadeloupe' }, { id: 'America/Guatemala', title : 'America/Guatemala' }, { id: 'America/Guayaquil', title : 'America/Guayaquil' }, { id: 'America/Guyana', title : 'America/Guyana' }, { id: 'America/Halifax', title : 'America/Halifax' }, { id: 'America/Havana', title : 'America/Havana' }, { id: 'America/Hermosillo', title : 'America/Hermosillo' }, { id: 'America/Indiana/Indianapolis', title : 'America/Indiana/Indianapolis' }, { id: 'America/Indiana/Knox', title : 'America/Indiana/Knox' }, { id: 'America/Indiana/Marengo', title : 'America/Indiana/Marengo' }, { id: 'America/Indiana/Petersburg', title : 'America/Indiana/Petersburg' }, { id: 'America/Indiana/Tell_City', title : 'America/Indiana/Tell City' }, { id: 'America/Indiana/Vevay', title : 'America/Indiana/Vevay' }, { id: 'America/Indiana/Vincennes', title : 'America/Indiana/Vincennes' }, { id: 'America/Indiana/Winamac', title : 'America/Indiana/Winamac' }, { id: 'America/Inuvik', title : 'America/Inuvik' }, { id: 'America/Iqaluit', title : 'America/Iqaluit' }, { id: 'America/Jamaica', title : 'America/Jamaica' }, { id: 'America/Juneau', title : 'America/Juneau' }, { id: 'America/Kentucky/Louisville', title : 'America/Kentucky/Louisville' }, { id: 'America/Kentucky/Monticello', title : 'America/Kentucky/Monticello' }, { id: 'America/La_Paz', title : 'America/La Paz' }, { id: 'America/Lima', title : 'America/Lima' }, { id: 'America/Los_Angeles', title : 'America/Los Angeles' }, { id: 'America/Maceio', title : 'America/Maceio' }, { id: 'America/Managua', title : 'America/Managua' }, { id: 'America/Manaus', title : 'America/Manaus' }, { id: 'America/Marigot', title : 'America/Marigot' }, { id: 'America/Martinique', title : 'America/Martinique' }, { id: 'America/Matamoros', title : 'America/Matamoros' }, { id: 'America/Mazatlan', title : 'America/Mazatlan' }, { id: 'America/Menominee', title : 'America/Menominee' }, { id: 'America/Merida', title : 'America/Merida' }, { id: 'America/Mexico_City', title : 'America/Mexico City' }, { id: 'America/Miquelon', title : 'America/Miquelon' }, { id: 'America/Moncton', title : 'America/Moncton' }, { id: 'America/Monterrey', title : 'America/Monterrey' }, { id: 'America/Montevideo', title : 'America/Montevideo' }, { id: 'America/Montreal', title : 'America/Montreal' }, { id: 'America/Montserrat', title : 'America/Montserrat' }, { id: 'America/Nassau', title : 'America/Nassau' }, { id: 'America/New_York', title : 'America/New York' }, { id: 'America/Nipigon', title : 'America/Nipigon' }, { id: 'America/Nome', title : 'America/Nome' }, { id: 'America/Noronha', title : 'America/Noronha' }, { id: 'America/North_Dakota/Center', title : 'America/North Dakota/Center' }, { id: 'America/North_Dakota/New_Salem', title : 'America/North Dakota/New Salem' }, { id: 'America/Ojinaga', title : 'America/Ojinaga' }, { id: 'America/Panama', title : 'America/Panama' }, { id: 'America/Pangnirtung', title : 'America/Pangnirtung' }, { id: 'America/Paramaribo', title : 'America/Paramaribo' }, { id: 'America/Phoenix', title : 'America/Phoenix' }, { id: 'America/Port-au-Prince', title : 'America/Port-au-Prince' }, { id: 'America/Port_of_Spain', title : 'America/Port of Spain' }, { id: 'America/Porto_Velho', title : 'America/Porto Velho' }, { id: 'America/Puerto_Rico', title : 'America/Puerto Rico' }, { id: 'America/Rainy_River', title : 'America/Rainy River' }, { id: 'America/Rankin_Inlet', title : 'America/Rankin Inlet' }, { id: 'America/Recife', title : 'America/Recife' }, { id: 'America/Regina', title : 'America/Regina' }, { id: 'America/Resolute', title : 'America/Resolute' }, { id: 'America/Rio_Branco', title : 'America/Rio Branco' }, { id: 'America/Santa_Isabel', title : 'America/Santa Isabel' }, { id: 'America/Santarem', title : 'America/Santarem' }, { id: 'America/Santiago', title : 'America/Santiago' }, { id: 'America/Santo_Domingo', title : 'America/Santo Domingo' }, { id: 'America/Sao_Paulo', title : 'America/Sao Paulo' }, { id: 'America/Scoresbysund', title : 'America/Scoresbysund' }, { id: 'America/Shiprock', title : 'America/Shiprock' }, { id: 'America/St_Barthelemy', title : 'America/St Barthelemy' }, { id: 'America/St_Johns', title : 'America/St Johns' }, { id: 'America/St_Kitts', title : 'America/St Kitts' }, { id: 'America/St_Lucia', title : 'America/St Lucia' }, { id: 'America/St_Thomas', title : 'America/St Thomas' }, { id: 'America/St_Vincent', title : 'America/St Vincent' }, { id: 'America/Swift_Current', title : 'America/Swift Current' }, { id: 'America/Tegucigalpa', title : 'America/Tegucigalpa' }, { id: 'America/Thule', title : 'America/Thule' }, { id: 'America/Thunder_Bay', title : 'America/Thunder Bay' }, { id: 'America/Tijuana', title : 'America/Tijuana' }, { id: 'America/Toronto', title : 'America/Toronto' }, { id: 'America/Tortola', title : 'America/Tortola' }, { id: 'America/Vancouver', title : 'America/Vancouver' }, { id: 'America/Whitehorse', title : 'America/Whitehorse' }, { id: 'America/Winnipeg', title : 'America/Winnipeg' }, { id: 'America/Yakutat', title : 'America/Yakutat' }, { id: 'America/Yellowknife', title : 'America/Yellowknife' },
					{ id: 'Antarctica/Casey', title : 'Antarctica/Casey' }, { id: 'Antarctica/Davis', title : 'Antarctica/Davis' }, { id: 'Antarctica/DumontDUrville', title : 'Antarctica/DumontDUrville' }, { id: 'Antarctica/Macquarie', title : 'Antarctica/Macquarie' }, { id: 'Antarctica/Mawson', title : 'Antarctica/Mawson' }, { id: 'Antarctica/McMurdo', title : 'Antarctica/McMurdo' }, { id: 'Antarctica/Palmer', title : 'Antarctica/Palmer' }, { id: 'Antarctica/Rothera', title : 'Antarctica/Rothera' }, { id: 'Antarctica/South_Pole', title : 'Antarctica/South Pole' }, { id: 'Antarctica/Syowa', title : 'Antarctica/Syowa' }, { id: 'Antarctica/Vostok', title : 'Antarctica/Vostok' }, 
					{ id:  'Asia/Aden', title : 'Asia/Aden'}, { id: 'Asia/Almaty', title : 'Asia/Almaty'}, { id: 'Asia/Amman', title : 'Asia/Amman'}, { id: 'Asia/Anadyr', title : 'Asia/Anadyr'}, { id: 'Asia/Aqtau', title : 'Asia/Aqtau'}, { id: 'Asia/Aqtobe', title : 'Asia/Aqtobe'}, { id: 'Asia/Ashgabat', title : 'Asia/Ashgabat'}, { id: 'Asia/Baghdad', title : 'Asia/Baghdad'}, { id: 'Asia/Bahrain', title : 'Asia/Bahrain'}, { id: 'Asia/Baku', title : 'Asia/Baku'}, { id: 'Asia/Bangkok', title : 'Asia/Bangkok'}, { id: 'Asia/Beirut', title : 'Asia/Beirut'}, { id: 'Asia/Bishkek', title : 'Asia/Bishkek'}, { id: 'Asia/Brunei', title : 'Asia/Brunei'}, { id: 'Asia/Choibalsan', title : 'Asia/Choibalsan'}, { id: 'Asia/Chongqing', title : 'Asia/Chongqing'}, { id: 'Asia/Colombo', title : 'Asia/Colombo'}, { id: 'Asia/Damascus', title : 'Asia/Damascus'}, { id: 'Asia/Dhaka', title : 'Asia/Dhaka'}, { id: 'Asia/Dili', title : 'Asia/Dili'}, { id: 'Asia/Dubai', title : 'Asia/Dubai'}, { id: 'Asia/Dushanbe', title : 'Asia/Dushanbe'}, { id: 'Asia/Gaza', title : 'Asia/Gaza'}, { id: 'Asia/Harbin', title : 'Asia/Harbin'}, { id: 'Asia/Ho_Chi_Minh', title : 'Asia/Ho Chi Minh'}, { id: 'Asia/Hong_Kong', title : 'Asia/Hong Kong'}, { id: 'Asia/Hovd', title : 'Asia/Hovd'}, { id: 'Asia/Irkutsk', title : 'Asia/Irkutsk'}, { id: 'Asia/Jakarta', title : 'Asia/Jakarta'}, { id: 'Asia/Jayapura', title : 'Asia/Jayapura'}, { id: 'Asia/Jerusalem', title : 'Asia/Jerusalem'}, { id: 'Asia/Kabul', title : 'Asia/Kabul'}, { id: 'Asia/Kamchatka', title : 'Asia/Kamchatka'}, { id: 'Asia/Karachi', title : 'Asia/Karachi'}, { id: 'Asia/Kashgar', title : 'Asia/Kashgar'}, { id: 'Asia/Kathmandu', title : 'Asia/Kathmandu'}, { id: 'Asia/Kolkata', title : 'Asia/Kolkata'}, { id: 'Asia/Krasnoyarsk', title : 'Asia/Krasnoyarsk'}, { id: 'Asia/Kuala_Lumpur', title : 'Asia/Kuala Lumpur'}, { id: 'Asia/Kuching', title : 'Asia/Kuching'}, { id: 'Asia/Kuwait', title : 'Asia/Kuwait'}, { id: 'Asia/Macau', title : 'Asia/Macau'}, { id: 'Asia/Magadan', title : 'Asia/Magadan'}, { id: 'Asia/Makassar', title : 'Asia/Makassar'}, { id: 'Asia/Manila', title : 'Asia/Manila'}, { id: 'Asia/Muscat', title : 'Asia/Muscat'}, { id: 'Asia/Nicosia', title : 'Asia/Nicosia'}, { id: 'Asia/Novokuznetsk', title : 'Asia/Novokuznetsk'}, { id: 'Asia/Novosibirsk', title : 'Asia/Novosibirsk'}, { id: 'Asia/Omsk', title : 'Asia/Omsk'}, { id: 'Asia/Oral', title : 'Asia/Oral'}, { id: 'Asia/Phnom_Penh', title : 'Asia/Phnom Penh'}, { id: 'Asia/Pontianak', title : 'Asia/Pontianak'}, { id: 'Asia/Pyongyang', title : 'Asia/Pyongyang'}, { id: 'Asia/Qatar', title : 'Asia/Qatar'}, { id: 'Asia/Qyzylorda', title : 'Asia/Qyzylorda'}, { id: 'Asia/Rangoon', title : 'Asia/Rangoon'}, { id: 'Asia/Riyadh', title : 'Asia/Riyadh'}, { id: 'Asia/Sakhalin', title : 'Asia/Sakhalin'}, { id: 'Asia/Samarkand', title : 'Asia/Samarkand'}, { id: 'Asia/Seoul', title : 'Asia/Seoul'}, { id: 'Asia/Shanghai', title : 'Asia/Shanghai'}, { id: 'Asia/Singapore', title : 'Asia/Singapore'}, { id: 'Asia/Taipei', title : 'Asia/Taipei'}, { id: 'Asia/Tashkent', title : 'Asia/Tashkent'}, { id: 'Asia/Tbilisi', title : 'Asia/Tbilisi'}, { id: 'Asia/Tehran', title : 'Asia/Tehran'}, { id: 'Asia/Thimphu', title : 'Asia/Thimphu'}, { id: 'Asia/Tokyo', title : 'Asia/Tokyo'}, { id: 'Asia/Ulaanbaatar', title : 'Asia/Ulaanbaatar'}, { id: 'Asia/Urumqi', title : 'Asia/Urumqi'}, { id: 'Asia/Vientiane', title : 'Asia/Vientiane'}, { id: 'Asia/Vladivostok', title : 'Asia/Vladivostok'}, { id: 'Asia/Yakutsk', title : 'Asia/Yakutsk'}, { id: 'Asia/Yekaterinburg', title : 'Asia/Yekaterinburg'}, { id: 'Asia/Yerevan', title : 'Asia/Yerevan' },
					{ id:  'Atlantic/Azores', title : 'Atlantic/Azores' }, { id: 'Atlantic/Bermuda', title : 'Atlantic/Bermuda' }, { id: 'Atlantic/Canary', title : 'Atlantic/Canary' }, { id: 'Atlantic/Cape_Verde', title : 'Atlantic/Cape Verde' }, { id: 'Atlantic/Faroe', title : 'Atlantic/Faroe' }, { id: 'Atlantic/Madeira', title : 'Atlantic/Madeira' }, { id: 'Atlantic/Reykjavik', title : 'Atlantic/Reykjavik' }, { id: 'Atlantic/South_Georgia', title : 'Atlantic/South Georgia' }, { id: 'Atlantic/St_Helena', title : 'Atlantic/St Helena' }, { id: 'Atlantic/Stanley', title : 'Atlantic/Stanley' }, 
					{ id:  'Australia/ACT', title : 'Australia/ACT' }, { id: 'Australia/Adelaide', title : 'Australia/Adelaide' }, { id: 'Australia/Brisbane', title : 'Australia/Brisbane' }, { id: 'Australia/Broken_Hill', title : 'Australia/Broken Hill' }, { id: 'Australia/Canberra', title : 'Australia/Canberra' }, { id: 'Australia/Currie', title : 'Australia/Currie' }, { id: 'Australia/Darwin', title : 'Australia/Darwin' }, { id: 'Australia/Eucla', title : 'Australia/Eucla' }, { id: 'Australia/Hobart', title : 'Australia/Hobart' }, { id: 'Australia/LHI', title : 'Australia/LHI' }, { id: 'Australia/Lindeman', title : 'Australia/Lindeman' }, { id: 'Australia/Lord_Howe', title : 'Australia/Lord Howe' }, { id: 'Australia/Melbourne', title : 'Australia/Melbourne' }, { id: 'Australia/North', title : 'Australia/North' }, { id: 'Australia/NSW', title : 'Australia/NSW' }, { id: 'Australia/Perth', title : 'Australia/Perth' }, { id: 'Australia/Queensland', title : 'Australia/Queensland' }, { id: 'Australia/South', title : 'Australia/South' }, { id: 'Australia/Sydney', title : 'Australia/Sydney' }, { id: 'Australia/Tasmania', title : 'Australia/Tasmania' }, { id: 'Australia/Victoria', title : 'Australia/Victoria' }, { id: 'Australia/West', title : 'Australia/West' }, { id: 'Australia/Yancowinna', title : 'Australia/Yancowinna' },
					{ id: 'Europe/Amsterdam', title : 'Europe/Amsterdam' }, { id: 'Europe/Andorra', title : 'Europe/Andorra' }, { id: 'Europe/Athens', title : 'Europe/Athens' }, { id: 'Europe/Belgrade', title : 'Europe/Belgrade' }, { id: 'Europe/Berlin', title : 'Europe/Berlin' }, { id: 'Europe/Bratislava', title : 'Europe/Bratislava' }, { id: 'Europe/Brussels', title : 'Europe/Brussels' }, { id: 'Europe/Bucharest', title : 'Europe/Bucharest' }, { id: 'Europe/Budapest', title : 'Europe/Budapest' }, { id: 'Europe/Chisinau', title : 'Europe/Chisinau' }, { id: 'Europe/Copenhagen', title : 'Europe/Copenhagen' }, { id: 'Europe/Dublin', title : 'Europe/Dublin' }, { id: 'Europe/Gibraltar', title : 'Europe/Gibraltar' }, { id: 'Europe/Guernsey', title : 'Europe/Guernsey' }, { id: 'Europe/Helsinki', title : 'Europe/Helsinki' }, { id: 'Europe/Isle_of_Man', title : 'Europe/Isle of Man' }, { id: 'Europe/Istanbul', title : 'Europe/Istanbul' }, { id: 'Europe/Jersey', title : 'Europe/Jersey' }, { id: 'Europe/Kaliningrad', title : 'Europe/Kaliningrad' }, { id: 'Europe/Kiev', title : 'Europe/Kiev' }, { id: 'Europe/Lisbon', title : 'Europe/Lisbon' }, { id: 'Europe/Ljubljana', title : 'Europe/Ljubljana' }, { id: 'Europe/London', title : 'Europe/London' }, { id: 'Europe/Luxembourg', title : 'Europe/Luxembourg' }, { id: 'Europe/Madrid', title : 'Europe/Madrid' }, { id: 'Europe/Malta', title : 'Europe/Malta' }, { id: 'Europe/Mariehamn', title : 'Europe/Mariehamn' }, { id: 'Europe/Minsk', title : 'Europe/Minsk' }, { id: 'Europe/Monaco', title : 'Europe/Monaco' }, { id: 'Europe/Moscow', title : 'Europe/Moscow' }, { id: 'Europe/Oslo', title : 'Europe/Oslo' }, { id: 'Europe/Paris', title : 'Europe/Paris' }, { id: 'Europe/Podgorica', title : 'Europe/Podgorica' }, { id: 'Europe/Prague', title : 'Europe/Prague' }, { id: 'Europe/Riga', title : 'Europe/Riga' }, { id: 'Europe/Rome', title : 'Europe/Rome' }, { id: 'Europe/Samara', title : 'Europe/Samara' }, { id: 'Europe/San_Marino', title : 'Europe/San Marino' }, { id: 'Europe/Sarajevo', title : 'Europe/Sarajevo' }, { id: 'Europe/Simferopol', title : 'Europe/Simferopol' }, { id: 'Europe/Skopje', title : 'Europe/Skopje' }, { id: 'Europe/Sofia', title : 'Europe/Sofia' }, { id: 'Europe/Stockholm', title : 'Europe/Stockholm' }, { id: 'Europe/Tallinn', title : 'Europe/Tallinn' }, { id: 'Europe/Tirane', title : 'Europe/Tirane' }, { id: 'Europe/Uzhgorod', title : 'Europe/Uzhgorod' }, { id: 'Europe/Vaduz', title : 'Europe/Vaduz' }, { id: 'Europe/Vatican', title : 'Europe/Vatican' }, { id: 'Europe/Vienna', title : 'Europe/Vienna' }, { id: 'Europe/Vilnius', title : 'Europe/Vilnius' }, { id: 'Europe/Volgograd', title : 'Europe/Volgograd' }, { id: 'Europe/Warsaw', title : 'Europe/Warsaw' }, { id: 'Europe/Zagreb', title : 'Europe/Zagreb' }, { id: 'Europe/Zaporozhye', title : 'Europe/Zaporozhye' }, { id: 'Europe/Zurich', title : 'Europe/Zurich' },
					{ id: 'Indian/Antananarivo', title : 'Indian/Antananarivo' }, { id: 'Indian/Chagos', title : 'Indian/Chagos' }, { id: 'Indian/Christmas', title : 'Indian/Christmas' }, { id: 'Indian/Cocos', title : 'Indian/Cocos' }, { id: 'Indian/Comoro', title : 'Indian/Comoro' }, { id: 'Indian/Kerguelen', title : 'Indian/Kerguelen' }, { id: 'Indian/Mahe', title : 'Indian/Mahe' }, { id: 'Indian/Maldives', title : 'Indian/Maldives' }, { id: 'Indian/Mauritius', title : 'Indian/Mauritius' }, { id: 'Indian/Mayotte', title : 'Indian/Mayotte' }, { id: 'Indian/Reunion', title : 'Indian/Reunion' },
					{ id: 'Pacific/Apia', title : 'Pacific/Apia' }, { id: 'Pacific/Auckland', title : 'Pacific/Auckland' }, { id: 'Pacific/Chatham', title : 'Pacific/Chatham' }, { id: 'Pacific/Chuuk', title : 'Pacific/Chuuk' }, { id: 'Pacific/Easter', title : 'Pacific/Easter' }, { id: 'Pacific/Efate', title : 'Pacific/Efate' }, { id: 'Pacific/Enderbury', title : 'Pacific/Enderbury' }, { id: 'Pacific/Fakaofo', title : 'Pacific/Fakaofo' }, { id: 'Pacific/Fiji', title : 'Pacific/Fiji' }, { id: 'Pacific/Funafuti', title : 'Pacific/Funafuti' }, { id: 'Pacific/Galapagos', title : 'Pacific/Galapagos' }, { id: 'Pacific/Gambier', title : 'Pacific/Gambier' }, { id: 'Pacific/Guadalcanal', title : 'Pacific/Guadalcanal' }, { id: 'Pacific/Guam', title : 'Pacific/Guam' }, { id: 'Pacific/Honolulu', title : 'Pacific/Honolulu' }, { id: 'Pacific/Johnston', title : 'Pacific/Johnston' }, { id: 'Pacific/Kiritimati', title : 'Pacific/Kiritimati' }, { id: 'Pacific/Kosrae', title : 'Pacific/Kosrae' }, { id: 'Pacific/Kwajalein', title : 'Pacific/Kwajalein' }, { id: 'Pacific/Majuro', title : 'Pacific/Majuro' }, { id: 'Pacific/Marquesas', title : 'Pacific/Marquesas' }, { id: 'Pacific/Midway', title : 'Pacific/Midway' }, { id: 'Pacific/Nauru', title : 'Pacific/Nauru' }, { id: 'Pacific/Niue', title : 'Pacific/Niue' }, { id: 'Pacific/Norfolk', title : 'Pacific/Norfolk' }, { id: 'Pacific/Noumea', title : 'Pacific/Noumea' }, { id: 'Pacific/Pago_Pago', title : 'Pacific/Pago Pago' }, { id: 'Pacific/Palau', title : 'Pacific/Palau' }, { id: 'Pacific/Pitcairn', title : 'Pacific/Pitcairn' }, { id: 'Pacific/Pohnpei', title : 'Pacific/Pohnpei' }, { id: 'Pacific/Port_Moresby', title : 'Pacific/Port Moresby' }, { id: 'Pacific/Rarotonga', title : 'Pacific/Rarotonga' }, { id: 'Pacific/Saipan', title : 'Pacific/Saipan' }, { id: 'Pacific/Tahiti', title : 'Pacific/Tahiti' }, { id: 'Pacific/Tarawa', title : 'Pacific/Tarawa' }, { id: 'Pacific/Tongatapu', title : 'Pacific/Tongatapu' }, { id: 'Pacific/Wake', title : 'Pacific/Wake' }, { id: 'Pacific/Wallis', title : 'Pacific/Wallis' },
					{ id: 'CET', title : 'CET' }, { id: 'EET', title : 'EET' }, { id: 'EST', title : 'EST' }, { id: 'GMT', title : 'GMT' }, { id: 'UTC', title : 'UTC' }
				]
				
			}
		},
		
		methods: {
			CheckWhiteLabel() {
				let that = this
				
				if(that.$store.state.user.plan_name == "Whitelabel" || that.$store.state.user.plan_name == "Sumo21" || that.$store.state.user.plan_name == "White" ) {
					
					that.$store.state.selectedPage = 'whitelabel'
					if(that.$route.path != '/account/whitelabel'){
						that.$router.push({ path: '/account/whitelabel' })
					}
					
				} else {
					that.$bvModal.show('modal-check-access')
				}
				
				// :to="{ path: '/account/whitelabel' }"
			},
			changeLocale(entry) {
				let that = this
				i18n.locale = entry.language;
				that.userLanguage.title = entry.title
				that.userLanguage.flag	= entry.flag
			},
			
			isMobile() {
				// const isMobile = window.matchMedia("only screen and (max-width: 760px)")
				// console.log( isMobile.matches )
				if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
					return true;
				} else {
					return false;
				}
			},
			
			notifyMe(message, variant){
				this.$notify({
					group	: 'foo',
					// title: 'Important message',
					text	: message,
					type	: variant,
					// duration: 5000,
					// speed	: 1000
				});
			},
			SeePlans () {
				let that = this
				that.$bvModal.hide('modal-check-access')
				that.$bvModal.show('modal-plans')
			},
			ShowModalAdd() {
				let that = this
				that.loadingAction = true
				// action :  workspace         si workspace a ajouter
				// action : member             si member a ajouter
				let url   = '/user/can'
				let method= 'GET'
				let data  = { action: 'workspace' }
				that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
					if( response.data.can ) {
						
						that.$bvModal.show('modal-add-client')
						let clientSelected 	= JSON.parse( localStorage.getItem('oml-client') ) 
						let country_code 	= clientSelected.country_code
						let timezone 		= clientSelected.timezone
						that.clientArray.country_code = country_code != null ? country_code : ''
						that.clientArray.timezone	  = timezone != null ? timezone : ''
						
					} else {
						that.$bvModal.show('modal-check-access')
					}
					that.loadingAction = false
				}).catch(( {response} ) => {
					that.notifyMe(response.data.message, 'warn')
					that.loadingAction = false
				})
			},
			
			closeModalClient() {
				this.$bvModal.hide('modal-list-clients')
				location.reload()
			},
			
			addClient() {
				let that = this
				that.is_empty = false
				
				if( that.clientArray.name == "" ) {
					that.is_empty = true
					return false
				}
				that.loadingAction = true
				
				let url   = '/client/createclient'
				let method= 'POST'
				let data  = {name:that.clientArray.name, country_code:that.clientArray.country_code, timezone:that.clientArray.timezone}
				that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
					// window.open("/settings/clients", '_self')
					let client = response.data.data.clients
					localStorage.setItem('oml-client' , JSON.stringify( client ) )
					
					that.$store.state.WorkSpaces = []
					that.notifyMe('Your workspace has been added successfully', 'success')
					that.$bvModal.hide('modal-add-client');
					that.loadingAction = false
					location.reload()
					// that.clientName = ""
				}).catch(( {response} ) => {
					that.notifyMe(response.data.message, 'warn')
					that.loadingAction = false
				})
			},
			doNotShowItAgain: function (){
				this.$cookies.set("demoModal", 'false', "30d")
				this.$bvModal.hide('modal-mobile')
			},	
			logout: function () {
				
				// this.$router.push('/logout')
				//
				/* let that = this
				that.$store.dispatch('logout')
				.then(() => {
					that.$http.defaults.headers.common['Authorization'] = ''
					that.$store.state.userToken = ''
					that.$store.state.status = ''
					that.$router.push('/')
				}) */
				
				// localStorage.removeItem('oml-token')
				// localStorage.removeItem('oml-user')
				// localStorage.removeItem('oml-client')
				// localStorage.removeItem('oml-clients')
				// localStorage.removeItem('user-teams')
				localStorage.clear()
				
				this.$http.defaults.headers.common['Authorization'] = ''
				this.$store.state.userToken = ''
				this.$store.state.status = ''
				this.$router.push('/')
			},
			
			// plans
			navbarInfo() {
				
				let that = this
				let url   = 'nav_bar'
				let method= 'GET'
				let data  = {}
				
				that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
					
					let myPlans = response.data.navbarInfo
					
					that.namePlans 		= myPlans.planName
					that.maxLeadsPlans 	= myPlans.maxLeads
					if(response.data.navbarInfo.maxLeads == '1000000'){
						that.maxLeadsPlans 	= '∞'
					}else{
						that.maxLeadsPlans 	= myPlans.maxLeads
					}
					that.leadsCountNav 	= myPlans.total
					
					that.percentage 	= myPlans.percent
					
				}).catch(( {response} ) => {
					console.log(response)
				})
				
			},
			
			selectClient(element) {
				
				let that = this
				if( element.enable ) {
					
					that.loadingAction = true
					let client   = that.$store.state.SelectedClient[0]
					let clients  = JSON.parse ( localStorage.getItem('oml-clients') )
					clients.forEach( function(item) {
						if( client == item.id ) {
							localStorage.setItem('oml-client', JSON.stringify(item) )
						}
					} )
					
				
					let url   = '/permissions'
					let method= 'POST'
					let data  = {custom : true}
						
					that.$store.dispatch('apiRequest', { url, method, data } ).then((response) => {
							
						this.$store.state.permissions = response.data
						//console.log('huss',this.$store.state.permissions)
							
					}).catch(( {response} ) => {
						console.log(response)
							
					})


					url   = 'client/selectclient'
					method= 'POST'
					data  = {}
					
					that.$store.dispatch('apiRequest', { url, method, data } ).then(() => {
						location.reload()
						that.loadingAction = false
					}).catch((  ) => {
						location.reload()
						that.loadingAction = false
					})
					
				} else {
					that.$bvModal.show('modal-check-access')
				}
			},
			
		},
		computed: {
			check_avatar() {
				let that = this
				if ( that.$auth.user() != null && typeof( that.$auth.user().avatar ) != 'undefined' ) {
					return that.$auth.user().avatar
				} else {
					return ''
				}
			},
			fullname() {
				let that = this
				// $store.state.user.name
				// if ( that.$auth.user() != null && typeof( that.$auth.user().name ) != 'undefined' ) {
				if ( that.$store.state.user != null && typeof( that.$store.state.user.name ) != 'undefined' ) {
					return that.$store.state.user.name
					// return that.$auth.user().name
				} else {
					return ''
				}
			},
			
			
		},
		
		mounted() {
			//
			console.log("modaldemo",this.$cookies.get('demoModal'))
			if(window.location.href.indexOf("https://console.ohmylead.com") !== -1){
				this.isWhiteLabel = false
			}else{
				this.isWhiteLabel = true
			}
			if(!this.isWhiteLabel){
					if(window.location.href.indexOf("https://console.ohmylead.com/demo") !== -1){
							console.log('none')
						}else{
							this.$bvModal.show('modal-mobile')
						}
			
			}
			

			let that = this
			that.CountryOptions = []
			that.countryList.forEach( function(country) {
				that.CountryOptions.push({ id: country.id, title: country.title + ' (' + country.id + ')', code: country.code})
			} )
			
			setTimeout(function() {
				that.$store.dispatch('GetClients')
			}, 1000)
			
			that.navbarInfo();
			
			if( that.$auth.user().email_verified_at == null || typeof( that.$auth.user().email_verified_at ) == 'undefined' ) {
				that.$emit('checkEmailVerification', 'check')
			}
			
			// that.GetTrial()
			that.$emit('GetTrial')
			
			let name  = this.fullname
			let email = this.$auth.user().email
			let created_at = this.$auth.user().created_at
			
			window.intercomSettings = {
				app_id	: "o6e94nop",
				name	: name, // Full name
				email	: email, // Email address
				created_at: created_at // Signup date as a Unix timestamp
			};
			
		}
	}
</script>

<style lang="scss">
	
	#modal-black-friday {
		.upgrade-el {
			margin-bottom: 24px;
			.p-upgrade {
				font-size: 16px;
				line-height: 26px;
				margin: 0;
				color: #fff;
			}
			.btn-upgrade-size {
				width: 259px;
				height: 51px;
				font-weight: 500;
				font-size: 15px;
				margin-bottom: 10px;
			}
		}
		.modal-body {
			background-color: #000;
			color: #fff;
		}
	}
	
	
	
	.nav-header-md .nav-md p.progress-bar-head {
		font-size: 12px !important;
		font-weight: 700 !important;
	}
	
	.nav-header-md .nav-md p.progress-bar-subhead {
		font-size: 12px !important;
		font-weight: 400 !important;
		
		b{
			font-weight: 700 !important;
		}
	}

	.progress-bar-content {
		margin-bottom: 4px !important;
		font-size: 12px !important;
		color: #848484 !important;
	}
	#modal-plans___BV_modal_content_ {
		
	}
	
	#modal-mobile___BV_modal_content_ {
		
		div {
			font-size: 30px;
		}
		b {
			font-size: 38px;
		}
		button {
			width: 40%;
			height: 4em;
			font-size: 20px;
			font-weight: 900;
		}
	}
	
	.upgrade-div {
		margin-bottom: 24px;
		
		.upgrade-img {
			width: 10em;
			margin-bottom: 22px;
		}
		
		.btn-upgrade-size {
			width: 259px;
			height: 51px;
			font-weight: 500;
			font-size: 15px;
			margin-bottom: 10px;
		}
		.p-upgrade {
			font-size: 19px;
			color: #1D2841;
			line-height: 26px;
		}
		
	}
	
	.btn-upgrade {
		color: #fff;
		background-color: #00BBF6;
		border-color: #00BBF6;
		&:hover {
			background-color: #01A3D6;
			border-color: #01A3D6;
			color: #fff;
			/* background-color: #fff;
			color: #00BBF6 !important; */
		}
	}
	
	.btn-outline-upgrade {
		color: #00BBF6;
		border-color: #00BBF6;
		&:hover {
			background-color: #00BBF6;
			color: #fff !important;
		}
	}
	
	.close-icon {
		position: absolute;
		right: 20px;
		top: 20px;
		font-size: 25px;
		cursor: pointer;
	}
	
	.help-text {
		font-size: 12px;
	}
	
	/* rightMenu ----------------------------- */
	.title-select {
		font-size: 14px;
		color: #212529;
	}

	.workspace-multiselect.select-dropdown .toggle-button{
		display:flex;
		align-items:center;
	}

	.nav-header-md {
		box-shadow: 0 1px 4px 0 #00000014;
		z-index: 999;
		background-color: #fff;
		position: sticky;
		top: 0px;
		
		img.img-md-profil {
			position: relative;
			top: 2px;
			width: 36px;
			height: 36px;
			min-width: 36px;
		}
		
		
		.panel-group {
			.done {
				color: green;
			}
		}
		
		.panel-heading {
			background-color: transparent;
			h4 {
				font-size: 18px;
			}
		}
		.sidebar {
			background: rgb(240, 248, 255);
			position: fixed;
			width: 100px;
			height: 100vh;
			right: -200px;
			top: 82px;
			padding: 20px;
			box-sizing: border-box;
			transition: ease-out 300ms;
		}
		.sidebar.active {
			right: 0;
			z-index: 1;
			width: 25%;
		}
		.overlay {
			position: fixed;
			top: 82px;
			display: none;
			left: 0;
			bottom: 0;
			right: 0;
			z-index: -1;
			transition: ease-out 300ms;
		}
		.overlay.active {
			z-index: 0;
			background-color: rgba(0, 0, 0, 0.2);
			display: block;
		}
		
		.nav-md {
			
			p.progress-bar-head {
				font-size: 14px;
				margin-bottom: 0px;
			}
			
			div.profil {
				
				.dropdown-menu {
					top: 2px!important;
					left: 0px!important;
					width: 300px !important;
					border: 1px solid #e0e0e0;
					border-radius: 2px;
				}
				
			}
			
			.dropdown-toggle::after {
				display: none;
			}
			.svg-span {
				font-size: 12px;
				color: #4caf50;
				padding-top: 5px;
			}
			
			.dropdown-menu>li>a:hover, .dropdown-menu>li>a:focus, .dropdown-menu>.active>a, .dropdown-menu>.active>a:hover, .dropdown-menu>.active>a:focus {
				// background-color: #fff;
				color: #000;
			}
			
			.dropdown-item.active, .dropdown-item:active, .dropdown-item:hover {
				background-color: #ffffff !important;
			}
			
			.item-content-md {
				
				a.dropdown-item {
					padding:0px;
					>span {
						border-bottom: 2px solid #f5f5f5;
						display: block;
						padding: 8px 0px;
						margin-left:20px;
						margin-right:20px;
						color: #2c3348;
						font-size: 13px;
						font-weight: 500;
						
						i {
							float: right;
							color: #ccc;
							position: relative;
							top: 4px;
						}
						&:hover {
							color: var(--secondary);
							
						}
					}
				}
				.b-dropdown-text {
					padding: 8px 20px;
				}
			}
			
			.add-actions-md {
				img {
					width: 40px;
					display: inline-block;
					padding-right: 10px;
					vertical-align: baseline;
				}
				.shortcut-menu-item-inner {
					display: inline-block;
					color: #283658;
					
					span {
						display: block;
						font-size: 13px;
						color: #999;
						margin-top: .2rem;
					}
					
				}
				
				ul {
					li {
						padding: 14px 0px;
					}
					li:hover {
						background-color: #f0f8ff !important;
						a:hover {
							background-color: #f0f8ff !important;
							color: #377cff !important;
						}
						
					}
				}
				
			}
			
		}
		
	}
	.get-started-btn {
    text-transform: uppercase;
    background: #ff5870;
    border: 2px solid #ff5870;
    padding: 5.5px 15px;
    color: #fff;
    font-weight: 900;
    letter-spacing: 1px;
    display: inline-block;
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 14px;
    transition: all .35s linear;
}

  .get-started  {
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 13px;
    color: #2b324a;
}
	
</style>